module.exports = __webpack_public_path__ + "files/78b08a68d05d5fabb0b8effd51bf6ade.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-700italic.ttf
 ** module id = 963
 ** module chunks = 0
 **/